import { Module } from 'vuex';
import { RootState } from '@/store/index';
import { getters } from '@/store/modules/lobby/getters';
import { actions } from '@/store/modules/lobby/actions';
import { mutations } from '@/store/modules/lobby/mutations';
import { HelpDeskDetailsModel } from '@/models/lobby/helpDeskDetails.model';

export interface LobbyState {
  helpDeskDetails: HelpDeskDetailsModel;
  changePasswordErrors: string[];
  userDataCleansingErrors: string[];
  performDataCleansingErrors: string[];
  lobbySuccessDialog: boolean;
  mustPerformDataCleansing: boolean;
  userPerformDataCleansing: boolean;
  mustChangePassword: boolean;
  performChangePassword: boolean;
  orgNews: string[];
  changePasswordLoading: boolean;
  changeUserDataCleansingLoading: boolean;
  openPopupChangesNotificationFlag: boolean;
}

export const initialState = ((): LobbyState => {
  return {
    helpDeskDetails: { technicalPhone: null, professionalPhone: null },
    changePasswordErrors: [],
    userDataCleansingErrors: [],
    performDataCleansingErrors: [],
    lobbySuccessDialog: false,
    mustPerformDataCleansing: false,
    userPerformDataCleansing: false,
    mustChangePassword: false,
    performChangePassword: false,
    orgNews: [],
    changePasswordLoading: false,
    changeUserDataCleansingLoading: false,
    openPopupChangesNotificationFlag: false,
  };
});

export const lobby: Module<LobbyState, RootState> = {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations,
};
